import { observer } from 'mobx-react-lite'
import React from 'react'
import { Box, EditableTitle, Icon, type IIconsVector, Tooltip } from 'shared/ui'
import { CHATBOT_NAME_LIMIT } from 'shared/constants/limits'

export type IAgentEditCustomTitle = {
  template?: {
    name: string
    icon: IIconsVector
  } | null
  name: string
  setName: (value: string) => void
  error?: string | null
  isAutoFocus?: boolean
}

export const AgentEditCustomTitle = observer(
  ({ template, name, setName, error, isAutoFocus }: IAgentEditCustomTitle) => (
    <Box display='flex' alignItems='center'>
      {template && (
        <Tooltip type='description' label={template.name} desc='Agent type'>
          <Icon
            icon={template.icon}
            color={'var(--content-brand-primary)'}
            fontSize={20}
            padding='0 8px 0 6px'
          />
        </Tooltip>
      )}
      <EditableTitle
        value={name}
        onChange={setName}
        error={error}
        limit={CHATBOT_NAME_LIMIT}
        isAutoFocus={isAutoFocus}
      />
    </Box>
  )
)
